export const BuildInfo = {timestamp:1770751177000}
